import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=1c5d1b0e&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=ts&"
export * from "./Reason.vue?vue&type=script&lang=ts&"
import style0 from "./Reason.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Reason.vue?vue&type=style&index=1&id=1c5d1b0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d1b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5d1b0e')) {
      api.createRecord('1c5d1b0e', component.options)
    } else {
      api.reload('1c5d1b0e', component.options)
    }
    module.hot.accept("./Reason.vue?vue&type=template&id=1c5d1b0e&scoped=true&", function () {
      api.rerender('1c5d1b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LossModal/Reason.vue"
export default component.exports